module.exports = __webpack_public_path__ + "static/img/mixins.138fd18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/frontProJect/fangzhou/mixins.png
// module id = WlXJ
// module chunks = 1